module.exports = __webpack_public_path__ + "img/Devices.99b8e6b9.svg";